import { objectLookup, setObjectValue } from "../../utils";
import { parseInclusionFilter } from "../../handlers/filter";
/**
 * Default find items logic — used if no findItems method is implemented
 * @param parent Parent object to lookup nestedItems on
 * @param filters Filters to apply to the lookup
 * @param handler Handler to use for finding items
 * @returns {Partial<ParentType>}
 */
const arrayFindItems = (parent, filters, handler) => {
    let valueOnParent = objectLookup(parent, handler.getKeyPath()) || [];
    if (!Array.isArray(valueOnParent)) {
        valueOnParent = [valueOnParent].filter((item) => item !== null && item !== undefined);
    }
    const identifiers = parseInclusionFilter(filters, handler.getIdentifierKey(), [
        "string",
        "number"
    ]);
    return valueOnParent.filter((nestedItem) => identifiers.has(handler.getIdentifier(nestedItem)));
};
/**
 * Default delete items logic — used if no deleteItems method is implemented
 * @param parent Parent object to delete nestedItems from
 * @param identifiers identifier(s) to delete
 * @param handler Handler to use for deleting items
 * @returns {Partial<ParentType>} - w/o nestedItems that match identifiers
 */
const arrayDeleteItems = (parent, identifiers, handler) => {
    const result = { ...parent };
    const valueOnParent = arrayNormalize(objectLookup(parent, handler.getKeyPath()));
    const identifierArray = Array.isArray(identifiers) ? identifiers : [identifiers];
    if (Array.isArray(valueOnParent)) {
        return setObjectValue(result, handler.getKeyPath(), valueOnParent.filter((nestedItem) => !identifierArray.includes(String(handler.getIdentifier(nestedItem)))));
    }
    return result;
};
/**
 * Default merging changes logic — used if no mergeChanges method is implemented
 * @param parent Parent to merge nestedItem into
 * @param nestedItem Partial nestedItem object to merge into parent
 * @param handler Handler to use for merging changes
 * @returns Partial<_ParentType>
 */
const arrayMergeChanges = (parent, nestedItem, handler) => {
    const valueOnParent = arrayNormalize(objectLookup(parent, handler.getKeyPath()));
    let isExistingItem = false;
    const nextItems = valueOnParent.reduce((acc, currentNested) => {
        if (handler.getIdentifier(currentNested) === handler.getIdentifier(nestedItem)) {
            isExistingItem = true;
            acc.push({ ...currentNested, ...nestedItem });
        }
        else {
            acc.push(currentNested);
        }
        return acc;
    }, []);
    if (!isExistingItem) {
        nextItems.push(nestedItem);
    }
    return setObjectValue(parent, handler.getKeyPath(), nextItems);
};
/**
 * Normalize value to an array of nested items
 * @param value The value to normalize
 * @returns An array of nested items
 */
const arrayNormalize = (value) => {
    if (Array.isArray(value)) {
        return value;
    }
    if (value === null || value === undefined) {
        return [];
    }
    return [value];
};
const array = {
    findItems: arrayFindItems,
    deleteItems: arrayDeleteItems,
    mergeChanges: arrayMergeChanges,
    normalize: arrayNormalize
};
export default {
    array
};
//# sourceMappingURL=utils.js.map